import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import App from './App.tsx';
import { ErrorBoundary } from './components/ErrorBoundary';
import { MissingConfiguration } from './components/MissingConfiguration';
import { SessionTimeout } from './components/SessionTimeout';
import { AuthProvider } from './contexts/AuthContext';
import { supabaseConfig } from './lib/supabase';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      {supabaseConfig.isConfigured ? (
        <BrowserRouter>
          <AuthProvider>
            <App />
            <SessionTimeout />
            <Toaster
              position="top-right"
              toastOptions={{
                className: 'bg-scale-darker text-white border border-gray-700',
                duration: 4000,
                style: {
                  background: '#1A2942',
                  color: '#fff',
                },
              }}
            />
          </AuthProvider>
        </BrowserRouter>
      ) : (
        <MissingConfiguration />
      )}
    </ErrorBoundary>
  </StrictMode>
);
